export function requestSid()
{
	return BX.ajax.runAction('redsign:school.captcha.getCaptchaSid');
}

export async function  updateSid(form)
{
	try
	{
		const sid = form.querySelector(`input[type="hidden"][name="captcha_sid"]`);
		const image = form.querySelector(`img[src*="/bitrix/tools/captcha.php"]`);
		const result = await this.requestSid();
		if (result.status === 'success')
		{
			const newSid = result.data;
			sid.value = newSid;
			image.src = `/bitrix/tools/captcha.php?captcha_sid=${newSid}`
		}
	}
	catch(e)
	{
		console.error(e);
	}
}